module.exports = __webpack_public_path__ + "index_pc/img/img_step.1c0d57aa.png";